import { render } from "./WebDevelopment.vue?vue&type=template&id=65b7cba7"
import script from "./WebDevelopment.vue?vue&type=script&lang=js"
export * from "./WebDevelopment.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\USER\\Desktop\\New folder\\Lynkme360\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__